import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GradingScheduleService} from "../../../../../shared/grading-schedule.service";
import {GradingScheduleList} from "../../../../../shared/interface/grading-schedule.interface";

@Component({
    selector: 'app-registrar-admin-maintenance-schedule-list',
    templateUrl: './schedule-list.component.html',
    styleUrls: ['./schedule-list.component.scss']
})
export class ScheduleListComponent implements OnInit {
    constructor(public gradingScheduleService: GradingScheduleService) {
    }

    panelOpenState = false;

    gradingSchedule: Array<GradingScheduleList>;
    pastGradingSchedule: Array<GradingScheduleList>;

    @Output() selectGradingSchedule = new EventEmitter<GradingScheduleList>();
    @Input() updateGradingSchedule: Array<GradingScheduleList>;
    @Input() formTermHasBeenLoaded: boolean;

    ngOnInit(): void {
        this.getScheduleList();
    }

    getScheduleList() {
        this.gradingSchedule = [];
        this.pastGradingSchedule = [];
        this.gradingScheduleService.getAllOpenForGrading().subscribe((response: Array<GradingScheduleList>) => {
            console.log('getAllOpenForGrading');
            console.log(response);
            this.gradingSchedule = response;
        });
        this.gradingScheduleService.getAllCloseForGrading().subscribe((response: Array<GradingScheduleList>) => {
            console.log('getAllCloseForGrading');
            console.log(response);
            this.pastGradingSchedule = response;
        });
    }

    editGradingSchedule(gradingSchedule: GradingScheduleList) {
        this.selectGradingSchedule.emit(gradingSchedule);
    }

    ngOnChanges(): void {

        if (this.updateGradingSchedule && this.formTermHasBeenLoaded) {
            this.getScheduleList();
        }
    }
}
